export default __webpack_public_path__ + "static/media/spaceExplorer_antennaHead.c9ad3baf.svg";